module.exports = __webpack_public_path__ + "img/17.5d78d845.jpg";